import {JoinSocialLeagueI18n} from '@/locales/base.message.locales';

export const join_social_league: JoinSocialLeagueI18n = {
  title: 'JOIN THE <span class="red--text">GLOBAL SOCIAL LEAGUE</span>',
  buttons: {
    contact_us: 'CONTACT US',
    donate: 'DONATE',
    join_today: 'JOIN TODAY'
  },
  texts: {
    p1: `We exist to facilitate people's awakening to do good in a contagious way, transforming the feling of empathy into actions of lasting effect through partnerships and open innovation:`,
    p2: `As a volunteer, collaborate with one of the IKONE UN SDGs' challenge teams and by lending your talent create a much bigger and scalable impact than just a financial donation.`,
    p3: `Your company can sponsor challenges through partnerships with the most effective and comprehensive global organizations committed to social impact, achieving a rate of return on investment of up to 20x.`,
    p4: `We encourage everyone to suggest challenges and use solutions to replicate in their communities.`
  },
};
